import React from "react";

import { DataInAnyRow } from "components/PageDashboard/ExternalCommitmentsSection/ExternalCommitmentsTable/ExternalCommitmentsTable";
import { ModalWizardStepRenderProps } from "components/ModalWizard/ModalWizard";

import StepBoolean from "components/StepBoolean";

function StepIsExternallyBookedMeeting({
	...props
}: ModalWizardStepRenderProps<DataInAnyRow>) {
	return <StepBoolean {...props} wizardDataKey="isExternallyBookedMeeting" />;
}

export default StepIsExternallyBookedMeeting;
